<nb-card (click)='gotoFacilityDetails(facilitySummary.facility.id)' *ngIf='facilitySummary'
         class='facility-extended-full'>
  <nb-card-header class='facility-card'>
    <div class='facility-header'>
      <div [nbTooltip]='notificationCounts()' class='facility-icon' nbTooltipPlacement='top'>
        <nb-icon
          class='{{ alertClass }}'
          icon='facility'
          nbPrefix
          pack='customIcons'
          status='control'
        ></nb-icon>
      </div>
      <div class='facility-details'>
        <div class='facility-details__name'>
          <h6>
            {{ facilitySummary.facility.name
            }}<span
          >{{ facilitySummary.terminalCounts.total }}
            {{ 'FACILITIES_SUMMARY.FACILITY.TERMINALS' | translate }}</span
          >
          </h6>
        </div>
        <div class='terminal-counts'>
          <ng-container *ngIf='facilitySummary.terminalCounts.total === 0'>
            <span>{{ facilitySummary.terminalCounts.offline }} Online</span>
          </ng-container>
          <ng-container
            *ngIf='
              facilitySummary.terminalCounts.total > 0 &&
                facilitySummary.terminalCounts.total === facilitySummary.terminalCounts.inUse;
              else offlineTemplate
            '
          >
            <div class='terminal-count-label'>
              <app-alarm-led [ledConfig]="{ label: false, color: 'green' }"></app-alarm-led>
              <span>{{ 'FACILITIES_SUMMARY.FACILITY.ALL_ONLINE' | translate }}</span>
            </div>
          </ng-container>
          <ng-template #offlineTemplate>
            <div *ngIf='facilitySummary.terminalCounts.offline > 0' class='terminal-count-label'>
              <app-alarm-led [ledConfig]="{ label: false, color: 'red' }"></app-alarm-led>
              <span
              >{{ facilitySummary.terminalCounts.offline }}
                {{ 'FACILITIES_SUMMARY.FACILITY.OFFLINE' | translate }}</span
              >
            </div>
            <div *ngIf='facilitySummary.terminalCounts.outOfUse > 0' class='terminal-count-label'>
              <app-alarm-led [ledConfig]="{ label: false, color: 'grey' }"></app-alarm-led>
              <span
              >{{ facilitySummary.terminalCounts.outOfUse }}
                {{ 'FACILITIES_SUMMARY.FACILITY.OUT_OF_USE' | translate }}</span
              >
            </div>
            <div *ngIf='facilitySummary.terminalCounts.inUse > 0' class='terminal-count-label'>
              <app-alarm-led [ledConfig]="{ label: false, color: 'green' }"></app-alarm-led>
              <span
              >{{ facilitySummary.terminalCounts.inUse }}
                {{ 'FACILITIES_SUMMARY.FACILITY.IN_USE' | translate }}</span
              >
            </div>
          </ng-template>
        </div>
      </div>
      <div class='alarms'>
        <app-facility-emergency-alarms
          [alarmsFromSummary]='facilitySummary.emergencyAlarms'
          [facilityId]='facilitySummary.facility.id'
          [showHeaderIcon]='false'
        ></app-facility-emergency-alarms>
        <div class='facility-navigation'>
          <a
            (click)='gotoFacilityDetails(facilitySummary.facility.id)'
            [routerLink]="['/status/facilities', facilitySummary.facility.id]"
          >
            <nb-icon
              class='icon-navigate'
              icon='arrow-ios-forward'
              nbPrefix
              pack='eva'
              status='control'
            ></nb-icon>
          </a>
        </div>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class='facility-extended-full__overview'>
      <div>
        <app-total-occupation-ratio
          [occupation]='facilitySummary.occupation'
        ></app-total-occupation-ratio>
      </div>
      <div class='activity'>
        <app-activity-chart
          [facilityId]='facilitySummary.facility.id'
          [showNavigation]='false'
          [style]="'activity-chart-low'"
          class='activity-chart'
        ></app-activity-chart>
      </div>
      <div>
        <app-other-occupation-ratio
          [occupation]='facilitySummary.occupation'
        ></app-other-occupation-ratio>
      </div>
    </div>
  </nb-card-body>
</nb-card>
